import { SVGProps } from "react";

interface XIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export default function XIcon({
  size = 16,
  className = "",
  ...props
}: XIconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
}
